import { gql } from 'apollo-angular';

export const GET_BRANCHES = gql`
  query branches($search: String) {
    branches(search: $search) {
      id
      branchName
      branchLogo
      address
      branchCode
      createdAt
      updatedAt
      status
      liscenseNumber
      managerId
      managerData {
        id
        firstName
        lastName
      }
    }
  }
`;
